import React from 'react'


import { cls } from 'tagged-classnames-free';
interface StickyFormActionLayoutProps {
  action: React.ReactNode
  children: React.ReactNode
  className?: string
  contentClassName?: string
  actionClassName?: string
}

const StickyFormActionLayout: React.FC<StickyFormActionLayoutProps> = (
  props,
) => {
  const { action, children, className, contentClassName, actionClassName } =
    props

  return (
    <div className={cls`flex flex-col ${className}`}>
      <div className={cls`pb-20 ${contentClassName}`}>{children}</div>
      <div
        className={cls`
          bg-f-bg-elevated sticky bottom-0 z-10 -mt-20 shrink-0 pb-6
          ${actionClassName}
        `}
      >
        {action}
      </div>
    </div>
  )
}

export default StickyFormActionLayout
